import { createRouter, createWebHashHistory } from "vue-router";
import { useUserStore } from "../stores/UserStore";
const routes = [
  {
    name: "HomePage",
    path: "/",
    component: () => import("@/pages/HomePage"),
  },
  {
    name: "LoginPage",
    path: "/login",
    component: () => import("@/pages/LoginPage"),
  },
  {
    name: "RegisterPage",
    path: "/register",
    component: () => import("@/pages/RegisterPage"),
  },
  {
    name: "DeviceListPage",
    path: "/devices",
    component: () => import("@/pages/Devices/ListPage"),
  },
  {
    name: "DeviceAddPage",
    path: "/device/add",
    component: () => import("@/pages/Devices/AddPage"),
  },
  {
    name: "DeviceDetailPage",
    path: "/device/:id",
    component: () => import("@/pages/Devices/DetailPage"),
  },
  {
    name: "DeviceEditPage",
    path: "/device/edit/:id",
    component: () => import("@/pages/Devices/EditPage"),
  },
  {
    name: "StationListPage",
    path: "/stations",
    component: () => import("@/pages/Stations/ListPage"),
  },
  {
    name: "DealersStationListPage",
    path: "/dealer_stations",
    component: () => import("@/pages/Stations/DealersStationListPage.vue"),
  },
  {
    name: "DealersStationAddPage",
    path: "/dealer_station/add",
    component: () => import("@/pages/Stations/DealersStationAddPage.vue"),
  },
  {
    name: "StationAddPage",
    path: "/station/add",
    component: () => import("@/pages/Stations/AddPage"),
  },
  {
    name: "StationEditPage",
    path: "/station/edit/:id",
    component: () => import("@/pages/Stations/EditPage"),
  },
  {
    name: "DealersStationEditPage",
    path: "/dealer_station/edit/:id",
    component: () => import("@/pages/Stations/DealersStationEditPage.vue"),
  },
  {
    name: "StationQueuePage",
    path: "/station_queue_system/:id",
    component: () => import("@/pages/Stations/StationQueuePage.vue"),
  },
  {
    name: "VehicleListPage",
    path: "/vehicles",
    component: () => import("@/pages/Vehicles/ListPage"),
  },
  {
    name: "VehicleAddPage",
    path: "/vehicle/add",
    component: () => import("@/pages/Vehicles/AddPage"),
  },
  {
    name: "VehicleEditPage",
    path: "/vehicle/edit/:plate",
    component: () => import("@/pages/Vehicles/EditPage"),
  },
  {
    name: "VehicleDetailPage",
    path: "/vehicle/:id",
    component: () => import("@/pages/Vehicles/DetailPage"),
  },
  {
    name: "VehicleJourneyPhotoPage",
    path: "/vehicle_journey_photos",
    component: () => import("@/pages/Vehicles/VehicleIbbPhotoPage.vue"),
  },
  {
    name: "VehicleJourneyPhotoDetailPage",
    path: "/vehicle_journey_photos/detail/:id",
    component: () => import("@/pages/Vehicles/VehicleIbbPhotoDetailPage.vue"),
  },
  {
    name: "DriverListPage",
    path: "/drivers",
    component: () => import("@/pages/Drivers/ListPage"),
  },
  {
    name: "DriverAddPage",
    path: "/driver/add",
    component: () => import("@/pages/Drivers/AddPage"),
  },
  {
    name: "DriverEditPage",
    path: "/driver/edit/:id",
    component: () => import("@/pages/Drivers/EditPage"),
  },
  {
    name: "DriverDetailPage",
    path: "/driver/:id",
    component: () => import("@/pages/Drivers/DetailPage"),
  },
  {
    name: "OwnersListPage",
    path: "/owners",
    component: () => import("@/pages/Owners/ListPage"),
  },
  {
    name: "OwnersAddPage",
    path: "/owner/add",
    component: () => import("@/pages/Owners/AddPage"),
  },
  {
    name: "OwnerEditPage",
    path: "/owner/edit/:id",
    component: () => import("@/pages/Owners/EditPage"),
  },
  {
    name: "OwnersDetailPage",
    path: "/owner/:id",
    component: () => import("@/pages/Owners/DetailPage"),
  },
  {
    name: "OwnerMapPage",
    path: "/owner_map",
    component: () => import("@/pages/Vehicles/OwnerMapPage.vue"),
  },
  {
    name: "OwnerFleetMapPage",
    path: "/owner_fleet_map/:id?",
    component: () => import("@/pages/Owners/OwnerFleetMapPage.vue"),
  },
  {
    name: "AdzoneListPage",
    path: "/adzones",
    component: () => import("@/pages/AdzoneListPage"),
  },
  {
    name: "AdzoneDetailPage",
    path: "/adzone/:id",
    component: () => import("@/pages/AdzoneDetailPage"),
  },
  {
    name: "AdsenseAddPage",
    path: "/adsense/add",
    component: () => import("@/pages/AdsenseAddPage"),
  },
  {
    name: "PageListPage",
    path: "/pages",
    component: () => import("@/pages/Authorities/PageListPage"),
  },
  {
    name: "TollHistoriesListPage",
    path: "/toll_histories",
    component: () => import("@/pages/TollHistoriesListPage"),
  },
  {
    name: "DealerListPage",
    path: "/dealers",
    component: () => import("@/pages/Dealers/ListPage"),
  },
  {
    name: "DealersAddPage",
    path: "/dealers/add",
    component: () => import("@/pages/Dealers/AddPage.vue"),
  },
  {
    name: "DealerEditPage",
    path: "/dealer/edit/:id",
    component: () => import("@/pages/Dealers/EditPage.vue"),
  },
  {
    name: "DealerDetailPage",
    path: "/dealer/detail/:id",
    component: () => import("@/pages/Dealers/DetailPage.vue"),
  },
  {
    name: "DealerDashboardPage",
    path: "/dealer/dashboard",
    component: () => import("@/pages/DealerDashboardPage.vue"),
  },
  {
    name: "İşlem Kaydı",
    path: "/servisislemkaydi",
    component: () => import("@/pages/Services/NewServices"),
  },
  {
    name: "NewServiceRecordPage",
    path: "/services/new_service_record",
    component: () => import("@/pages/Services/NewServicePage.vue"),
  },
  {
    name: "ServiceUpdatePage",
    path: "/services/service_update/:id",
    component: () => import("@/pages/Services/ServiceUpdatePage.vue"),
  },
  {
    name: "ServiceDetailPage",
    path: "/services/service_detail/:id",
    component: () => import("@/pages/Services/ServiceDetailPage.vue"),
  },
  {
    name: "WaitingProcessListPage",
    path: "/services/waiting_processes",
    component: () => import("@/pages/Services/WaitingProcesses/ListPage.vue"),
  },
  {
    name: "CompletedProcessListPage",
    path: "/services/completed_processes",
    component: () => import("@/pages/Services/CompletedProcesses/ListPage.vue"),
  },
  {
    name: "NewServiceMainRecordPage",
    path: "/main_services/new_service_record",
    component: () => import("@/pages/ServicesMain/NewServicePage.vue"),
  },
  {
    name: "ServiceMainUpdatePage",
    path: "/main_services/service_update/:id",
    component: () => import("@/pages/ServicesMain/ServiceUpdatePage.vue"),
  },
  {
    name: "ServiceMainDetailPage",
    path: "/main_services/service_detail/:id",
    component: () => import("@/pages/ServicesMain/ServiceDetailPage.vue"),
  },
  {
    name: "MainWaitingProcessListPage",
    path: "/main_services/waiting_processes",
    component: () =>
      import("@/pages/ServicesMain/WaitingProcesses/ListPage.vue"),
  },
  {
    name: "MainCompletedProcessListPage",
    path: "/main_services/completed_processes",
    component: () =>
      import("@/pages/ServicesMain/CompletedProcesses/ListPage.vue"),
  },
  {
    name: "InventoryListPage",
    path: "/inventories",
    component: () => import("@/pages/Inventories/ListPage"),
  },
  {
    name: "InventoryDetailPage",
    path: "/inventory/detail/:id",
    component: () => import("@/pages/Inventories/DetailPage"),
  },
  {
    name: "InventoryAddPage",
    path: "/inventory/add",
    component: () => import("@/pages/Inventories/AddPage"),
  },
  {
    name: "InventoryBulkAddPage",
    path: "/inventory/bulk-add",
    component: () => import("@/pages/Inventories/BulkAddPage.vue"),
  },
  {
    name: "InventoryEditPage",
    path: "/inventory/edit/:id",
    component: () => import("@/pages/Inventories/EditPage"),
  },
  {
    name: "InventoryStatusListPage",
    path: "/inventory_status",
    component: () => import("@/pages/Inventories/InventoryStatus/ListPage.vue"),
  },
  {
    name: "InventoryStatusAddPage",
    path: "/inventory_status/add",
    component: () => import("@/pages/Inventories/InventoryStatus/AddPage.vue"),
  },
  {
    name: "InventoryStatusEditPage",
    path: "/inventory_status/edit/:id",
    component: () => import("@/pages/Inventories/InventoryStatus/EditPage.vue"),
  },
  {
    name: "InventoryBrandListPage",
    path: "/inventory_brands",
    component: () => import("@/pages/Inventories/Brands/ListPage.vue"),
  },
  {
    name: "InventoryBrandAddPage",
    path: "/inventory_brand/add",
    component: () => import("@/pages/Inventories/Brands/AddPage.vue"),
  },
  {
    name: "InventoryBrandEditPage",
    path: "/inventory_brand/edit/:id",
    component: () => import("@/pages/Inventories/Brands/EditPage.vue"),
  },
  {
    name: "InventoryMeasurementListPage",
    path: "/inventory_measurements",
    component: () => import("@/pages/Inventories/Measurements/ListPage.vue"),
  },
  {
    name: "InventoryMeasurementAddPage",
    path: "/inventory_measurement/add",
    component: () => import("@/pages/Inventories/Measurements/AddPage.vue"),
  },
  {
    name: "InventoryMeasurementEditPage",
    path: "/inventory_measurement/edit/:id",
    component: () => import("@/pages/Inventories/Measurements/EditPage.vue"),
  },
  {
    name: "InventoryProductListPage",
    path: "/inventory_products",
    component: () => import("@/pages/Inventories/Products/ListPage.vue"),
  },
  {
    name: "InventoryProductAddPage",
    path: "/inventory_product/add",
    component: () => import("@/pages/Inventories/Products/AddPage.vue"),
  },
  {
    name: "InventoryProductEditPage",
    path: "/inventory_product/edit/:id",
    component: () => import("@/pages/Inventories/Products/EditPage.vue"),
  },
  {
    name: "InventoryCardStockListPage",
    path: "/inventory_card_stocks",
    component: () => import("@/pages/Inventories/CardStocks/ListPage.vue"),
  },
  {
    name: "InventoryCardStockAddPage",
    path: "/inventory_card_stock/add",
    component: () => import("@/pages/Inventories/CardStocks/AddPage.vue"),
  },
  {
    name: "InventoryCardStockEditPage",
    path: "/inventory_card_stock/edit/:id",
    component: () => import("@/pages/Inventories/CardStocks/EditPage.vue"),
  },
  {
    name: "PageAddPage",
    path: "/page/add",
    component: () => import("@/pages/Authorities/PageAddPage"),
  },
  {
    name: "UserListPage",
    path: "/users",
    component: () => import("@/pages/Authorities/UserListPage"),
  },
  {
    name: "UserAddPage",
    path: "/user/add",
    component: () => import("@/pages/Authorities/UserAddPage"),
  },
  {
    name: "UserEditPage",
    path: "/user/edit/:id",
    component: () => import("@/pages/Authorities/UserEditPage"),
  },
  {
    name: "UserPasswordChangeAdminPage",
    path: "/user/password_change_admin/:id",
    component: () =>
      import("@/pages/Authorities/UserPasswordChangeAdminPage.vue"),
  },
  {
    name: "RoleListPage",
    path: "/roles",
    component: () => import("@/pages/Authorities/RoleListPage"),
  },
  {
    name: "RoleAddPage",
    path: "/role/add",
    component: () => import("@/pages/Authorities/RoleAddPage"),
  },
  {
    name: "RolePermissionEdit",
    path: "/permission/role_edit/:id",
    component: () => import("@/pages/Authorities/RolePermissionEditPage"),
  },
  {
    name: "UserPermissionEdit",
    path: "/permission/user_edit/:id",
    component: () => import("@/pages/Authorities/UserPermissionEditPage"),
  },
  {
    name: "SubscriptionListPage",
    path: "/subscriptions",
    component: () => import("@/pages/Authorities/SubscriptionListPage"),
  },
  {
    name: "PaymentHistoryListPage",
    path: "/payment_histories",
    component: () => import("@/pages/Purchases/PaymentHistoryListPage"),
  },
  {
    name: "PayTrReportsPage",
    path: "/paytr_reports",
    component: () => import("@/pages/Purchases/PayTrReportsPage.vue"),
  },
  {
    name: "SubscriptionAddPage",
    path: "/subscriptions/add",
    component: () => import("@/pages/Authorities/SubscriptionAddPage"),
  },
  {
    name: "TravelRoutePage",
    path: "/travel/:travelid",
    component: () => import("@/pages/Vehicles/RoutePage"),
  },
  {
    name: "TariffListPage",
    path: "/tariffs",
    component: () => import("@/pages/Tariffs/ListPage"),
  },
  {
    name: "TariffAddPage",
    path: "/tariff/add",
    component: () => import("@/pages/Tariffs/AddPage"),
  },
  {
    name: "TariffHistoryListPage",
    path: "/tariff_histories",
    component: () => import("@/pages/TariffService/HistoryListPage"),
  },
  {
    name: "TariffReportPage",
    path: "/tariff_report",
    component: () => import("@/pages/TariffService/TariffReportPage"),
  },
  {
    name: "TariffMatchPage",
    path: "/tariff_match",
    component: () => import("@/pages/TariffService/TariffMatchPage"),
  },
  {
    name: "BulkTariffMatchPage",
    path: "/tariff_match/bulk",
    component: () => import("@/pages/TariffService/BulkTariffMatchPage.vue"),
  },
  {
    name: "ApproveImageListPage",
    path: "/pending_approval_images",
    component: () => import("@/pages/ApproveImageListPage"),
  },
  {
    name: "PasswordChangePage",
    path: "/password_change",
    component: () => import("@/pages/PasswordChange"),
  },
  {
    name: "TaximeterDataDateListPage",
    path: "/taximeter_data_dates",
    component: () => import("@/pages/TaximeterDataListPage"),
  },
  {
    name: "IntegrationPage",
    path: "/integration",
    component: () => import("@/pages/IntegrationPage"),
  },
  {
    name: "LogHistoryListPage",
    path: "/process_logs",
    component: () => import("@/pages/Logs/LogHistoryListPage"),
  },
  {
    name: "PlansPage",
    path: "/plans",
    component: () => import("@/pages/Purchases/PlansPage"),
  },
  {
    name: "InvoiceInfoPage",
    path: "/invoice_info",
    component: () => import("@/pages/Purchases/InvoiceInfoPage"),
  },
  {
    name: "RegionTariffListPage",
    path: "/region_tariffs",
    component: () => import("@/pages/Authorities/RegionTariffListPage"),
  },
  {
    name: "RegionTariffAddPage",
    path: "/region_tariff/add",
    component: () => import("@/pages/Authorities/RegionTariffAddPage"),
  },
  {
    name: "AdminPlansListPage",
    path: "/admin_plans",
    component: () => import("@/pages/Authorities/PlanListPage"),
  },
  {
    name: "AdminPlansAddPage",
    path: "/admin_plans/add",
    component: () => import("@/pages/Authorities/PlanAddPage"),
  },
  {
    name: "AdminPlansEditPage",
    path: "/admin_plans/edit/:id",
    component: () => import("@/pages/Authorities/PlanEditPage"),
  },
  {
    name: "AccountingReportPage",
    path: "/report_page",
    component: () => import("@/pages/AccountingReportPage"),
  },
  {
    name: "MDMConfigPage",
    path: "/mdm_configs",
    component: () => import("@/pages/MDMConfigListPage"),
  },
  {
    name: "MDMCreateVehiclePage",
    path: "/mdm_create_vehicle",
    component: () => import("@/pages/MDMCreateVehiclePage"),
  },
  {
    name: "MDMCreateVehicleWithConfigPage",
    path: "/mdm/create_with_config",
    component: () => import("@/pages/MDMCreateVehicleWithConfigPage"),
  },
  {
    name: "AdminVehicleListPage",
    path: "/admin_vehicle_list",
    component: () => import("@/pages/AdminVehicleListPage"),
  },
  {
    name: "AdminVehicleDetailPage",
    path: "/admin_vehicle_detail/:id",
    component: () => import("@/pages/AdminVehicleDetailPage"),
  },
  {
    name: "AddTollPage",
    path: "/add_toll",
    component: () => import("@/pages/TollSegments/AddTollPage"),
  },
  {
    name: "TollSegmentListPage",
    path: "/toll_segments",
    component: () => import("@/pages/TollSegments/ListTollPage"),
  },
  {
    name: "TollSegmentPriceEditPage",
    path: "/toll_segments_edit_price",
    component: () => import("@/pages/TollSegments/EditTollPricePage"),
  },
  {
    name: "MdmConfigurationListPage",
    path: "/mdm/configurations",
    component: () => import("@/pages/MdmServices/ConfigurationListPage"),
  },
  {
    name: "MdmDeviceListPage",
    path: "/mdm/devices",
    component: () => import("@/pages/MdmServices/DevicesListPage"),
  },
  {
    name: "MdmDeviceDetailPage",
    path: "/mdm/devices/:plate",
    component: () => import("@/pages/MdmServices/DeviceDetailPage"),
  },
  {
    name: "MdmMultipleDeviceUpdatePage",
    path: "/mdm/multiple_device_update",
    component: () => import("@/pages/MdmServices/MultipleDeviceUpdatePage.vue"),
  },
  {
    name: "MdmApplicationListPage",
    path: "/mdm/applications",
    component: () => import("@/pages/MdmServices/ApplicationListPage"),
  },
  {
    name: "WinFormLogListPage",
    path: "/winform_logs",
    component: () => import("@/pages/WinFormLogs/WinFormLogListPage"),
  },
  {
    name: "ServiceFaultListPage",
    path: "/service_faults/list",
    component: () => import("@/pages/ServiceFaults/ServiceFaultListPage"),
  },
  {
    // Telefondan QR ile fotoğraf yükleme: oturum açmadan çalışır, yalnızca QR'daki rastgele anahtarla yükleme yapar.
    name: "PhotoUploadPage",
    path: "/photo-upload/:token",
    component: () => import("@/pages/ServiceFaults/PhotoUploadPage"),
    meta: { public: true },
  },
  {
    name: "ServiceFaultDetailPage",
    path: "/service_faults/detail/:id",
    component: () => import("@/pages/ServiceFaults/ServiceFaultDetailPage"),
  },
  {
    name: "ServiceFaultSettingsPage",
    path: "/service_faults/settings",
    component: () => import("@/pages/ServiceFaults/ServiceFaultSettingsPage"),
  },
  {
    name: "ServiceFaultFormPage",
    path: "/service_faults/add",
    component: () => import("@/pages/ServiceFaults/ServiceFaultFormPage"),
  },
  {
    name: "ServiceFaultEditPage",
    path: "/service_faults/edit/:id",
    component: () => import("@/pages/ServiceFaults/ServiceFaultFormPage"),
  },
  {
    name: "SuccessPage",
    path: "/success",
    component: () => import("@/pages/Purchases/SuccessPage"),
  },
  {
    name: "FailPage",
    path: "/fail",
    component: () => import("@/pages/Purchases/FailPage"),
  },
  {
    name: "SettingPage",
    path: "/settings",
    component: () => import("@/pages/SettingPage"),
  },
  {
    name: "ErrorPage",
    path: "/error",
    component: () => import("@/pages/ErrorPage"),
  },
  {
    name: "DriverTemplatesListPage",
    path: "/driver_templates",
    component: () => import("@/pages/DriverTemplates/ListPage.vue"),
  },
  {
    name: "QrCodeListPage",
    path: "/qr_codes/list",
    component: () => import("@/pages/QrCodes/ListPage.vue"),
  },
  {
    name: "QrCodeAddPage",
    path: "/qr_codes/add",
    component: () => import("@/pages/QrCodes/AddPage.vue"),
  },
  {
    name: "QrCodeEditPage",
    path: "/qr_codes/edit/:id",
    component: () => import("@/pages/QrCodes/EditPage.vue"),
  },
  {
    name: "DeviceStatusListPage",
    path: "/device_statuses",
    component: () => import("@/pages/Devices/DeviceStatusListPage.vue"),
  },
  {
    name: "PanicAlertListPage",
    path: "/panic_alerts",
    component: () => import("@/pages/PanicAlerts/PanicAlertListPage.vue"),
  },
  {
    name: "NotificationListPage",
    path: "/notifications",
    component: () => import("@/pages/Notifications/NotificationListPage.vue"),
  },
  {
    name: "AdminNotificationListPage",
    path: "/admin_notifications",
    component: () => import("@/pages/Notifications/AdminNotificationListPage.vue"),
  },
  {
    name: "VehicleIbbPhotoSettingsPage",
    path: "/vehicle_journey_photos_settings",
    component: () => import("@/pages/Vehicles/VehicleIbbPhotoSettingsPage.vue"),
  },
  {
    name: "MicroKeysPage",
    path: "/micro/keys",
    component: () => import("@/pages/Micro/MicroKeysPage.vue"),
  },
  {
    name: "MicroTariffRequestsPage",
    path: "/micro/tariff_requests",
    component: () => import("@/pages/Micro/MicroTariffRequestsPage.vue"),
  },
  {
    name: "MicroLogsPage",
    path: "/micro/logs",
    component: () => import("@/pages/Micro/MicroLogsPage.vue"),
  },
  {
    name: "FirmwareListPage",
    path: "/firmwares/list",
    component: () => import("@/pages/Firmwares/ListPage.vue"),
  },
  {
    name: "DeviceManagementPage",
    path: "/firmwares/device-management",
    component: () => import("@/pages/Firmwares/DeviceManagement.vue"),
  },
  {
    name: "DeviceDetailVehiclePage",
    path: "/firmwares/device-detail/vehicle/:vehicleId",
    component: () => import("@/pages/Firmwares/DeviceDetailPage.vue"),
  },
  {
    name: "DeviceDetailDevicePage",
    path: "/firmwares/device-detail/device/:deviceType/:deviceKey",
    component: () => import("@/pages/Firmwares/DeviceDetailPage.vue"),
  },
  {
    name: "AppPage",
    path: "/apps",
    component: () => import("@/pages/AppPage"),
  },
  {
    name: "AppUploadPage",
    path: "/upload_app",
    component: () => import("@/pages/AppUploadPage"),
  },
  {
    name: "404Page",
    path: "/:catchAll(.*)", // Herhangi bir yol ile eşleşecek
    component: () => import("@/pages/404Page"), // 404 sayfası
  },
];
const router = createRouter({
  routes,
  history: createWebHashHistory(),
});
// Bu yolların altındaki sayfalar "Sayfa Yönetimi"nde kayıtlı olmak ve kullanıcıya yetki verilmiş olmak zorundadır.
// Kayıt yoksa diğer sayfalardaki gibi serbest bırakılmaz, erişim reddedilir.
const PROTECTED_PREFIXES = ["/micro/", "/admin_plans/edit/", "/admin_notifications"];

router.beforeEach(async (to, _, next) => {
  // Herkese açık sayfalar (telefondan fotoğraf yükleme) giriş ve sayfa yetkisi istemez
  if (to.meta?.public) return next();
  const userStore = useUserStore();
  const _isAuth = userStore.isAuthenticated;
  if (!_isAuth && to.fullPath != "/login") {
    next("/login");
  } else {
    if (to.fullPath === "/login") return next();
    let path = to.matched[0].path;
    let pathResponse = await userStore.getPagesByPathAction(path);

    if (pathResponse.statusCode !== 200 && path.startsWith("/")) {
      pathResponse = await userStore.getPagesByPathAction(path.slice(1));
    }

    if (pathResponse.statusCode === 200) {
      const checkAuth = await userStore.checkUserAuthLevelAction({
        pageID: pathResponse.data.pageID,
      });
      if (checkAuth.statusCode === 200) {
        if (checkAuth.data.permissionName !== "Unauthorized") {
          next();
        } else {
          next({ name: "ErrorPage" });
        }
      } else {
        next({ name: "ErrorPage" });
      }
    } else if (PROTECTED_PREFIXES.some((p) => path.toLowerCase().startsWith(p))) {
      next({ name: "ErrorPage" });
    } else {
      next();
    }
    // next();
  }
});
export default router;
